import { useElectronDeeplinks } from '@/hooks/useElectronDeepLinks'
import { useSyncExternalBadgeCount } from '@/hooks/useSyncExternalBadgeCount'

export const EmbeddedHooksManager = () => {
  useSyncExternalBadgeCount()
  useElectronDeeplinks()
  return false
}
